import React from 'react';
import LazyImage from '../../../CustomLibraries/LazyImage';
import Card from '../../components/Card';
import { grand_rounds_static_image } from '../../../../common/assets.common';
import { removeHtmlTags } from '../../../../pages/channel/utils';
import SpeakerDoc from '../SpeakerDoc';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Button } from 'react-bootstrap';
import InView from 'react-intersection-observer';
import { useTrackUserActivity } from '../../../customHooks/useTrackUserActivity';

const RelatedCard = ({
  featured = false,
  type = '',
  className = null,
  image = null,
  title = '',
  contentType = '',
  sessionDoctorDetails = [],
  sponsor_logo = [],
  icon,
  type_id,
  internalType,
  id,
  survey_id,
  pageId,
  fallbackImage = '',
  onClick = () => { }
}) => {
  const { userActivityTracker } = useTrackUserActivity();
  return (
    <Card className={`clr_v3_card__related hover-image cursorPointer ${className ?? ''}`} type={type}>
      <Card.Body>
        <InView
          threshold={1}
          as="div"
          onChange={(inView) => {
            userActivityTracker(
              inView,
              { type: internalType, type_id, id, survey_id },
              'card',
              pageId
            );
          }}
        >
          <div
            className={`d-flex gap-4 ${type === 'small' ? 'flex-row align-items-center' : 'flex-column'
              }`}
            onClick={onClick}
          >
            {/* flex-row */}
            <Card.Image className="cursorPointer">
              <LazyImage
                src={image}
                alt="banner"
                fallback_image={fallbackImage ?? grand_rounds_static_image}
                className={`object-fit-cover w-100 h-100`}
                extraClass="w-100 h-100 position-relative"
              />
            </Card.Image>

            <div className="d-flex flex-column">
              <span className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto cursorPointer gap-2 text-black">
                {!!icon && <i className={`${icon} fs-3 text-primary`}></i>}
                <span>{contentType}</span>
              </span>

              <Card.Title className="hover-opacity mt-1 cursorPointer">
                {removeHtmlTags(`${title}`)}
              </Card.Title>

              {/*  */}
              {type !== 'small' && <SpeakerDoc data={sessionDoctorDetails} />}
              {type !== 'small' && (
                <Card.Footer>
                  <Swiper
                    className="clr_v3_sponsor text-right me-0"
                    navigation={false}
                    spaceBetween={0}
                    slidesPerView={1}
                    loop={true}
                    autoplay={{
                      delay: 2500
                    }}
                    effect={'fade'}
                  >
                    {sponsor_logo &&
                      sponsor_logo?.length > 1 &&
                      sponsor_logo?.map((_sp, idx) => (
                        <SwiperSlide
                          key={idx + 1}
                          className="clr_v3_sponsor_slide w-100 position-relative"
                        >
                          <LazyImage
                            src={_sp}
                            alt="sponsor"
                            className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                            logo
                          />
                        </SwiperSlide>
                      ))}
                    {sponsor_logo &&
                      sponsor_logo?.length == 1 &&
                      sponsor_logo?.map((_sp, idx) => (
                        <div key={idx + 1} className="clr_v3_sponsor_slide w-100 position-relative">
                          <LazyImage
                            src={sponsor_logo[0]}
                            alt="sponsor"
                            className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                            logo
                          />
                        </div>
                      ))}
                  </Swiper>

                  <Button
                    variant="outline-primary"
                    className="ms-auto rounded-2 text-nowrap py-2 px-3"
                  >
                    View Details
                  </Button>
                </Card.Footer>
              )}
              {/*  */}
            </div>
          </div>
        </InView>
      </Card.Body>
      {/* card comments end */}
      {/* <CommentsAtEnd /> */}
    </Card>
  );
};

export default RelatedCard;
